export const CHANGE_ITEM_SELECTED_POPUP = 'CHANGE_ITEM_SELECTED_POPUP';
export const CHANGE_CATEGORY = 'CHANGE_CATEGORY';
export const CHANGE_SELECTED_ITEMS = 'CHANGE_SELECTED_ITEMS';

export const changeItemSelectedPopup = (item: any) => ({
    type: CHANGE_ITEM_SELECTED_POPUP,
    payload: item
});

export const changeCategory = (category: any) => ({
    type: CHANGE_CATEGORY,
    payload: category
});

export const changeSelectedItems = (items: any[]) => ({
    type: CHANGE_SELECTED_ITEMS,
    payload: items
});
